import { inject, Injectable } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';

/**
 * Bundle Manager Service provides helper functions and service to work with bundle
 */
@Injectable({ providedIn: 'root' })
export class BundleHelperService {
  private readonly statefulService = inject(StatefulService);

  /**
   * Force the bundle to make GET call to bundle api and refresh the bundle in UI
   */
  public refreshBundle(callBack?: () => void): void {
    this.statefulService.wrap('api:consumerId').load(callBack);
  }

  /**
   * Refresh the bundle asynchronously.
   */
  public refreshBundleAsync(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.refreshBundle(() => {
        resolve(true);
      });
    });
  }

  /**
   * Force the bundle to make GET call to bundle api and refresh the bundle in UI
   */
  public refreshOLABundle(callBack?: () => void): void {
    this.statefulService.wrap('ola:consumerId').load(callBack);
  }

  /**
   * Refresh the bundle asynchronously.
   */
  public refreshOLABundleAsync(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.refreshOLABundle(() => {
        resolve(true);
      });
    });
  }
}
